import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare global {
  interface Window {
    ePayco?: any;
  }
}

@Injectable({ providedIn: 'root' })
export class EpaycoLoaderService {
  private loaded = false;
  private promise?: Promise<any>;

  load(): Promise<any> {
    if (window.ePayco) return Promise.resolve(window.ePayco);
    if (this.promise) return this.promise;

    this.promise = new Promise((resolve, reject) => {
      const existing = document.querySelector(
        'script[src="https://checkout.epayco.co/checkout.js"]'
      );
      if (existing) {
        console.info('[ePayco] checkout.js ya cargado');
        this.loaded = true;
        resolve(window.ePayco);
        return;
      }
      const s = document.createElement('script');
      s.src = 'https://checkout.epayco.co/checkout.js'; // loader oficial
      s.async = true;

      s.onload = () => {
        this.loaded = true;
        console.info('[ePayco] checkout.js cargado correctamente');
        if (window.ePayco) resolve(window.ePayco);
        else reject(new Error('ePayco no inicializó el objeto global.'));
      };

      s.onerror = () => reject(new Error('No se pudo cargar checkout.js'));
      document.head.appendChild(s);
    });

    return this.promise;
  }
}
